import { render } from "./DetectionDialog.vue?vue&type=template&id=22bfe366&ts=true"
import script from "./DetectionDialog.vue?vue&type=script&lang=ts"
export * from "./DetectionDialog.vue?vue&type=script&lang=ts"

import "./DetectionDialog.vue?vue&type=style&index=0&id=22bfe366&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__